<div class="main-content">
    <div class="nav-area">
        <div class="nav-desktop">
            <div class="logo-login">
                <img src="assets/img/navbar/Join logo vector.png" alt="">
                <div [routerLink]="'/login'" class="log-in">
                    <img src="assets/img/sign-up/login.svg" alt="">
                    <span class="span-one">Log In</span>
                </div>
            </div>
            <div class="privacy-legal-notice">
                <span [routerLink]="'/privacy-sign-in'" class="span-two">Privacy Policy</span>
                <span [routerLink]="'/legal-notice-sign-in'" class="span-three">Legal notice</span>
            </div>
        </div></div>
    <div class="main-content-input">
    <header>
        <img src="assets/img/header/Logo.png" alt="">
        <div class="header-title">Kanban Project Management Tool</div>
    </header>
        <div class="contractDetails">
            <h1 class="DieterHeading1">Imprint</h1>
            <h2 class="HeadingLeft"><span>Provider</span></h2>
            <p class="Body">Irina Gorges</p>
            <p class="Body"><span class="multiline">Bachstr. 37
                37574 Einbeck</span>
            </p>
            <h2 class="HeadingLeft"><span>Contact us</span></h2>
            <p class="Body">E-Mail: irinagorges&#64;live.de</p>
            <p class="Body">Phone: 017064665231</p>
            <h2 class="HeadingLeft"><span>Data protection notice</span></h2>
            <p class="Body">You can find our Privacy Policy at: <a href="https://join.irina-gorges.de/#/privacy-sign-in" target="_blank">https://join.irina-gorges.de/#/privacy-sign-in</a></p>
            <h2 class="HeadingLeft"><span>Copyright notice</span></h2>
            <p class="Body">The texts, images, photos, videos or graphics available on our website are generally subject to copyright protection. Any unauthorized use (especially copying, editing or distribution) of this copyright-protected content is therefore prohibited. If you intend to use this content or parts thereof, please contact us in advance using the details above. If we are not the owner of the required copyrighted rights of use ourselves, we will endeavor to arrange contact with the entitled party.</p>
            <p class="DieterSmall"><span><i>Created with the kind support of </i></span>
                <a href="https://www.dieter-datenschutz.de/">
                    <span><i>Dieter does data protection</i></span>
                </a>
            </p>
        </div>
    </div>
</div>
<div class="nav-mobile">
    <div class="logo-login-mobile" [routerLink]="'/login'">
        <img src="assets/img/sign-up/login.svg" alt="">
        <span class="span-one-mobile">Log In</span>
    </div>
    <div class="privacy-legal-notice-mobile">
        <span [routerLink]="'/privacy-sign-in'" class="span-two-mobile">Privacy Policy</span>
        <span [routerLink]="'/legal-notice-sign-in'" class="span-three-mobile">Legal notice</span>
    </div>
</div>